import { defineStore } from "pinia";
import {
  SIDEBAR_TYPE,
  TOGGLE_NAV_THEME,
  TOGGLE_LAYOUT,
  TOGGLE_FIXED_HEADER,
  TOGGLE_FIXED_SIDEBAR,
  TOGGLE_CONTENT_WIDTH,
  TOGGLE_HIDE_HEADER,
  TOGGLE_COLOR,
  TOGGLE_WEAK,
  TOGGLE_MULTI_TAB,
  APP_LANGUAGE
} from "@/store/mutation-types.js";
import { loadLanguageAsync } from "@/locales/index.js";
import storage from "@/utils/storage.js";

export const useAppStore = defineStore("app", {
  state: () => ({
    sideCollapsed: storage.get(SIDEBAR_TYPE, false),
    theme: storage.get(TOGGLE_NAV_THEME, "dark"),
    layout: storage.get(TOGGLE_LAYOUT, ""),
    contentWidth: storage.get(TOGGLE_CONTENT_WIDTH, ""),
    fixedHeader: storage.get(TOGGLE_FIXED_HEADER, false),
    fixedSidebar: storage.get(TOGGLE_FIXED_SIDEBAR, false),
    autoHideHeader: storage.get(TOGGLE_HIDE_HEADER, false),
    color: storage.get(TOGGLE_COLOR, ""),
    weak: storage.get(TOGGLE_WEAK, false),
    multiTab: storage.get(TOGGLE_MULTI_TAB, true),
    lang: storage.get(APP_LANGUAGE, "zh-CN"),
    _antLocale: {},
    loading: false
  }),
  actions: {
    setLoading(loading) {
      this.loading = loading;
    },
    [SIDEBAR_TYPE](type) {
      this.sideCollapsed = type;
    },
    [TOGGLE_NAV_THEME](theme) {
      this.theme = theme;
    },
    [TOGGLE_LAYOUT](mode) {
      this.layout = mode;
    },
    [TOGGLE_FIXED_HEADER](mode) {
      this.fixedHeader = mode;
    },
    [TOGGLE_FIXED_SIDEBAR](mode) {
      this.fixedSidebar = mode;
    },
    [TOGGLE_CONTENT_WIDTH](type) {
      this.contentWidth = type;
    },
    [TOGGLE_HIDE_HEADER](type) {
      this.autoHideHeader = type;
    },
    [TOGGLE_COLOR](color) {
      this.color = color;
    },
    [TOGGLE_WEAK](mode) {
      this.weak = mode;
    },
    [APP_LANGUAGE](lang, antd = {}) {
      this.lang = lang;
      this._antLocale = antd;
    },
    [TOGGLE_MULTI_TAB](bool) {
      this.multiTab = bool;
    },
    setLang(lang) {
      this[APP_LANGUAGE](lang);
      return loadLanguageAsync(lang);
    }
  },
  persist: {
    key: "app",
    storage: localStorage,
    pick: [
      "sideCollapsed",
      "theme",
      "layout",
      "contentWidth",
      "fixedHeader",
      "fixedSidebar",
      "autoHideHeader",
      "color",
      "weak",
      "multiTab",
      "lang"
    ]
  }
});

export default useAppStore;
